// extracted by mini-css-extract-plugin
export default {"processing":"AddPaymentMethod_processing__g+0Qr","message":"AddPaymentMethod_message__6KNzp"};